import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { LectionaryItemMap, Proper } from 'app/objects';
import { LectionaryItemNameService, LectionaryItemName, LectionaryItemNameSummary } from '../../services/lectionary-item-name.service';
import { LectionaryItemTypeService, LectionaryItemType } from '../../services/lectionary-item-type.service';
import { EditEntityBaseClass } from '../EditEntityBaseClass';
import { LectionarySourceService, LectionarySource } from '../../services/lectionary-source.service';
import { LectionaryYearService } from '../../services/lectionary-year.service';
import { LectionaryTrackService } from '../../services/lectionary-track.service';
import { LectionaryYear } from '../lectionary-year/lectionary-year.component';
import { LectionaryTrack } from '../lectionary-track/lectionary-track.component'; 
import { LiturgyTypeService, LiturgyType } from '../../services/liturgy-type.service';
import { MappingsService } from '../../services/mappings.service';
import { ProperService } from '../../services/proper.service';

@Component({
  selector: 'app-mappings-edit',
  templateUrl: './mappings-edit.component.html',
  styleUrls: ['./mappings-edit.component.css']
})
export class MappingsEditComponent extends EditEntityBaseClass  implements OnInit {
 
  @Input() public map: LectionaryItemMap;
  @Input() public isProper: boolean;
  @Output() public closed: EventEmitter<void> = new EventEmitter();
 
  public listsLoaded = false;
  public isLoadingLectionaryItemNames = false;
  public header = "Edit Map";

  public lectionaryItemTypes: LectionaryItemType[];
  public lectionarySources: LectionarySource[];
  public lectionaryYears: LectionaryYear[];
  public lectionaryTracks: LectionaryTrack[]; 
  public liturgyTypes: LiturgyType[];
  public lectionaryItemNames: LectionaryItemNameSummary[];
  public propers: Proper[];

  constructor(
    private lectionaryItemNameSvc: LectionaryItemNameService,
    private lectionaryItemTypeSvc: LectionaryItemTypeService,
    private lectionaryYearSvc: LectionaryYearService,
    private lectionaryTrackSvc: LectionaryTrackService, 
    private liturgyTypeSvc: LiturgyTypeService,
    private lectionarySourceSvc: LectionarySourceService,
    private properSvc: ProperService,
    private mappingsSvc: MappingsService
    ) { 
      super();
    }

    ngOnChanges(changes: any) {
      console.log(changes.map); 

      if (this.map != null) {
        if (this.map.LectionaryItemType != null) {
          this.getLectionaryItemNames(this.map.LectionaryItemType.Id);
        }
      }
    }

  ngOnInit() {
 
    var promises = [];

    promises.push(this.lectionaryItemTypeSvc.loadEntities().then(
      (data) => {
        this.lectionaryItemTypes = data;
      }
    ));
  
    promises.push(this.lectionarySourceSvc.loadEntites().then(
      (data) => {
        this.lectionarySources = data;
      }
    ));

    promises.push(this.lectionaryYearSvc.loadEntites().then(
      (data) => {
        this.lectionaryYears = data;
      }
    ));

    promises.push(this.lectionaryTrackSvc.loadEntites().then(
      (data) => {
        this.lectionaryTracks = data;
      }
    ));
 

    promises.push(this.liturgyTypeSvc.loadEntites().then(
      (data) => {
        this.liturgyTypes = data;
      }
    ));


    promises.push(this.properSvc.loadEntites().then(
      (data) => {
        this.propers = data;
      }
    ));
  
    Promise.all(promises).then(
      (data) => {
        console.log("All promises are completed", this.lectionaryItemTypes);
        this.listsLoaded = true;
      }
    );



  }


  private getLectionaryItemNames(lectionaryItemTypeId: number) {
    
    this.lectionaryItemNames = [];
 
    console.log("getLectionaryItemNames", lectionaryItemTypeId);
    if (lectionaryItemTypeId == null) return; 

    this.isLoadingLectionaryItemNames = true; 
    var lectionaryItemNamePromise = this.lectionaryItemNameSvc.loadSummaryEntitiesByLectionaryItemTypeId(lectionaryItemTypeId).then(
      (data) => {
        this.lectionaryItemNames = data;
        this.isLoadingLectionaryItemNames = false; 
      }, 
      (err) => { 
        alert("Could not load the lectionary item names");
        console.log(err);
        this.isLoadingLectionaryItemNames = false;
      }
    );

  }

  private lectionaryItemTypeValueChanged(e : any) { 
    console.log("lectionaryItemTypeValueChanged EVENT:", e);

    var type = this.lectionaryItemTypes.find(s=> s.Id == e);
    console.log("LectionaryType", type);

    this.map.LectionaryItemType = type;

    this.getLectionaryItemNames(this.map.LectionaryItemType.Id);

    if (this.map.LectionaryItemType == null) {
      this.map.LectionaryItemType = {
        Id: null, 
        Localized: null,
        ReligionBranch: null, 
        DesignatedLectionaryItemType: null,
        SubTypes: null
      }
    }

  }


  private lectionaryItemTypeSubTypeValueChanged(e : any) { 
    console.log("lectionaryItemTypeSubTypeValueChanged EVENT:", e);
 
    var match = this.map.LectionaryItemType.SubTypes.find((s)=> s.Id === e);
    this.map.LectionaryItemTypeSubType = match;
  }

  private save() {
    console.log("save", this.map);
    
     
    if (this.map.LectionaryItemType == null || this.map.LectionaryItemType.Id == null) {
      alert("Please select a lectionary item type");
      return;
    }

    if (this.map.LectionaryItemType.SubTypes != null && this.map.LectionaryItemType.SubTypes.length > 0) {
      if (this.map.LectionaryItemTypeSubType == null) {
        alert("Please select a lectionary item sub type");
        return;
      }
    }

    if (this.map.LectionaryItemName == null || this.map.LectionaryItemName.Id == null) {
      alert("Please select a lectionary item name");
      return;
    }
    
    if (this.map.LectionarySource == null || this.map.LectionarySource.Id == null) {
      alert("Please select a map source");
      return;
    }

    this.mappingsSvc.save(this.map).then(
      () => { 
        console.log("Map saved");
        this.closed.emit();
      }
    ).catch(
      (err) => {
        var msg ="Could not save map: " + err;
        console.error("Error saving map", err);
        alert(msg);
      }
    )
  }

  private cancel() {
    this.closed.emit();
  }



}
